import { IconPaths, ModalSize } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from 'app/components'
import { TelekitModal } from '../modal/TelekitModal'

export const TelekitsListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openModal = () =>
    showModal({
      title: 'Criar Telekit',
      content: <TelekitModal />,
      size: ModalSize.Medium,
    })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openModal}>
      {t('common.add')}
    </Button>
  )
}
